module.exports = __webpack_public_path__ + "static/media/Lampe.7745f162.png";